import { useMutation } from "@apollo/client";
import { DELETE_LIST_ITEMS } from "../../../graphql/mutation/ListItems";
import { Button, Modal } from "../../ui";

const RemoveSelected = (props = {}) => {
  const {
    ids,
    listId,
    onSuccess,
    listItemIds = ids, // some modules might pass down only "ids" which are listItem ids
  } = props;
  const disabled = !listItemIds?.length > 0;
  const [deleteListItems, { loading }] = useMutation(DELETE_LIST_ITEMS, {
    refetchQueries: ["FetchListItems"],
  });

  const handleClick = closeModal => async e => {
    e.preventDefault();
    await deleteListItems({
      variables: {
        input: {
          ids: listItemIds,
        },
      },
      update: (cache, { data }) => {
        const { deleteListItems: { success } = {} } = data;
        if (success) {
          listItemIds?.forEach(id => {
            cache.evict({
              id: cache.identify({
                __typename: "ListItem",
                id,
              }),
            });
          });
          // identify list id and update count
          cache.modify({
            id: cache.identify({
              __typename: "List",
              id: listId,
            }),
            fields: {
              itemsCount(value) {
                return value - listItemIds?.length;
              },
            },
          });
          onSuccess?.();
          closeModal();
        }
      },
    });
  };

  const modalProps = {
    title: "",
    scale: "sm",
    hideCloseButton: true,
    closeOnBackdrop: false,
    disabled,
    body: ({ closeModal }) => {
      return (
        <div className={`p-4`}>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div className={`text-lg`}>Confirmation</div>
            <div className="flex flex-wrap gap-2 sm:gap-4">
              <Button
                className={`!w-22`}
                action="default"
                label="Cancel"
                onClick={closeModal}
              />
              <Button
                loading={loading}
                className={`!w-22 flex items-center`}
                label={loading ? "Removing..." : "Remove"}
                onClick={handleClick(closeModal)}
              />
            </div>
          </div>
          <div className="mt-8 text-sm font-normal">
            Selected items will be removed from working select list.{" "}
            <b>Confirm?</b>
          </div>
        </div>
      );
    },
  };

  return (
    <Modal {...modalProps}>
      <Button
        label={"Remove Selected"}
        disabled={disabled}
        className={`flex items-center`}
      />
    </Modal>
  );
};

export default RemoveSelected;
